import type {
  GetIdsFromSnapshot,
  ReplaceIdsFromSnapshot,
} from '../interactivityActionSnapshotMetadata';
import { InteractivityActionTypeValue } from '../InteractivityActionTypeValue';
import type { PlayAnimationInteractivityActionSnapshotOut } from './PlayAnimationInteractivityAction';

const replaceItemIdsFromSnapshot: ReplaceIdsFromSnapshot<
  PlayAnimationInteractivityActionSnapshotOut
> = (snapshot, replaceId) => {
  if (snapshot.targetItemId) {
    snapshot.targetItemId = replaceId(snapshot.targetItemId);
  }
};

const getItemIdsFromSnapshot: GetIdsFromSnapshot<
  PlayAnimationInteractivityActionSnapshotOut
> = snapshot => (snapshot.targetItemId ? [snapshot.targetItemId] : []);

export const playAnimationInteractivityActionSnapshotMetadata = {
  typeId: InteractivityActionTypeValue.PlayAnimation,
  replaceItemIdsFromSnapshot,
  getItemIdsFromSnapshot,
};
